import { FiberPinTwoTone } from '@material-ui/icons';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {FAS_FILE_API} from '../../assets/constants/ApiUrl'
import axios from 'axios';
declare var BASE_URL_FAS: string;
declare var BASE_URL_USER: string;
interface FileBrief {
	fileid:string
	title: string,
	description: string,
	filterKey: string,
	owner:string,
	visibility:boolean,
	company:string,
	createTime:string,
	permision: Permission
}
interface Permission {
	upload:boolean,
	download:boolean
}
interface PermittedFileList{
	permissionList: Array<FileBrief>
	lastKey:Object
}


interface InputData{
	userID:string,
	count:number,
	searchKey:string,
	searchKeyValue:string,
	lastEvaluatedPartitionKey:string,
	lastEvaluatedSortKey:string
}
export const fetchMorePermittedFileList = createAsyncThunk(
	'file/morefilebrief',
	async(data:InputData,thunkapi)=>{
		try{
			const response = await axios.get(FAS_FILE_API,{ params: data,withCredentials: true })
			return response.data as PermittedFileList
		}
		catch(e){
			console.log(e)
		}
	}
)